import creditEngineRepository, { CreditEngineRepository } from "./CreditEngineRepository";

const resource = "/creditAssessment/emi";
export default {
  getEmiSchemes(
    clientId, profession, category, brand, model, price, officeId, partnerName, loanId
  ) {
    const httpParams = {
      clientId: clientId,
      profession: profession,
      category: category,
      brand: brand,
      model: model,
      price: price,
      officeId: officeId,
      loanId: loanId,
      partnerName: partnerName
    };

    return CreditEngineRepository.get(`${resource}/list`, { params: httpParams });
  },

  saveEmiScheme(emiScheme) {
    creditEngineRepository.setContentType("application/json")
    return CreditEngineRepository.post(`${resource}/save`, emiScheme);
  }
};
